export { pageCreateCommand } from './page_create';

import { pageCreateCommand } from './page_create';

export const pageCommands = [
  pageCreateCommand,
];
